'use strict';

const HavenCart = (() => {
  const drawer = () => document.getElementById('haven-cart-drawer');
  const overlay = () => document.getElementById('haven-cart-overlay');
  const countEl = () => document.querySelectorAll('[data-haven-cart-count]');

  function open() {
    const d = drawer();
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    d.classList.add('is-open');
    overlay()?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    d.querySelector('[data-haven-cart-close]')?.focus();
  }

  function close() {
    const d = drawer();
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    d.classList.remove('is-open');
    overlay()?.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function renderLineItems(cart) {
    const container = document.getElementById('haven-cart-items');
    if (!container) return;

    if (cart.item_count === 0) {
      container.innerHTML = '<p class="haven-cart__empty">Your bag is empty — let\'s fix that.</p>';
      return;
    }

    container.innerHTML = cart.items.map(item => `
      <div class="haven-cart__item" data-key="${item.key}">
        <a href="${item.url}" class="haven-cart__item-image-link">
          <img src="${item.image}" alt="${item.title}" width="80" height="80" loading="lazy">
        </a>
        <div class="haven-cart__item-info">
          <p class="haven-cart__item-title">${item.product_title}</p>
          ${item.variant_title ? `<p class="haven-cart__item-variant">${item.variant_title}</p>` : ''}
          <div class="haven-cart__item-qty">
            <button class="haven-cart__qty-btn" data-action="decrease" data-key="${item.key}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button class="haven-cart__qty-btn" data-action="increase" data-key="${item.key}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <p class="haven-cart__item-price">${formatMoney(item.final_line_price)}</p>
        <button class="haven-cart__remove" data-key="${item.key}" aria-label="Remove ${item.title}">×</button>
      </div>
    `).join('');

    document.getElementById('haven-cart-subtotal')?.replaceChildren(
      Object.assign(document.createElement('span'), { textContent: formatMoney(cart.total_price) })
    );
  }

  function updateCount(count) {
    countEl().forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  async function refreshDrawer() {
    const cart = await fetchCart();
    await renderLineItems(cart);
    updateCount(cart.item_count);
  }

  async function addItem(variantId, quantity = 1, properties = {}) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity, properties })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    await refreshDrawer();
    open();
  }

  async function changeItem(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    await refreshDrawer();
  }

  function bindEvents() {
    document.addEventListener('click', async e => {
      if (e.target.closest('[data-haven-cart-open]')) { open(); return; }
      if (e.target.closest('[data-haven-cart-close]')) { close(); return; }
      if (e.target.closest('#haven-cart-overlay')) { close(); return; }

      const qtyBtn = e.target.closest('.haven-cart__qty-btn');
      if (qtyBtn) {
        const key = qtyBtn.dataset.key;
        const item = document.querySelector(`.haven-cart__item[data-key="${key}"]`);
        const currentQty = parseInt(item?.querySelector('span')?.textContent || '1');
        const newQty = qtyBtn.dataset.action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
        await changeItem(key, newQty);
        return;
      }

      const removeBtn = e.target.closest('.haven-cart__remove');
      if (removeBtn) {
        await changeItem(removeBtn.dataset.key, 0);
        return;
      }
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') close();
    });

    document.addEventListener('haven:addtocart', async e => {
      const { variantId, quantity, properties } = e.detail || {};
      if (variantId) await addItem(variantId, quantity, properties);
    });
  }

  function init() {
    bindEvents();
    refreshDrawer();
  }

  return { init, open, close, addItem, refreshDrawer };
})();

document.addEventListener('DOMContentLoaded', () => HavenCart.init());
